import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  procedureExecutionService,
  type StepComment,
} from '../services/procedure-execution.service';
import { procedureExecutionKeys } from './useProcedureExecution';

export function useStepComments(inspectionId: string, stepExecId: string, enabled: boolean) {
  return useQuery({
    queryKey: procedureExecutionKeys.stepComments(inspectionId, stepExecId),
    queryFn: () => procedureExecutionService.listComments(inspectionId, stepExecId),
    staleTime: 15_000,
    enabled: enabled && !!inspectionId && !!stepExecId,
  });
}

export function useAddComment(inspectionId: string, stepExecId: string) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (comment: string) =>
      procedureExecutionService.addComment(inspectionId, stepExecId, comment),

    onSuccess: (newComment) => {
      qc.setQueryData<StepComment[]>(
        procedureExecutionKeys.stepComments(inspectionId, stepExecId),
        (prev) => [...(prev ?? []), newComment],
      );
    },
  });
}
